import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule, ErrorHandler, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import { AppRoutingModule } from '@app/app-routing.module';
import { AppComponent } from '@app/app.component';

import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
// @ts-ignore
import { HttpClient, HttpClientModule, HttpErrorResponse } from '@angular/common/http';

import { RestApiService } from '@app/shared/services/rest-api.service';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { LoginComponent } from './pages/login/login.component';
import { RecoveryPasswordComponent } from './pages/recoveryPassword/recoveryPassword.component';
import { environment } from '../environments/environment';

import { CommonModule, LocationStrategy, HashLocationStrategy } from '@angular/common';
// @ts-ignore
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MenuComponent } from './components/menu/menu.component';
import { SessionService } from './shared/services/session.service';
import { SidemenuComponent } from './components/sidemenu/sidemenu.component';
import { SubmenuComponent } from './components/submenu/submenu.component';
import { SocietyListComponent } from './pages/users/society-list/society-list.component';
import { ReservationListComponent } from './pages/reservations/reservation-list/reservation-list.component';
import { CarSharingComponent } from "./pages/carsharing/carsharing.component";
import { VirementsListComponent } from './pages/facturations/virements-list/virements-list.component';
import { GainComponent } from './pages/facturations/gain/gain.component';
import { ControlComponent } from './pages/facturations/control/control.component';
import { MyReservationComponent } from './pages/reservations/reservation-me/reservation-me.component';
import { UserListComponent } from './pages/users/user-list/user-list.component';
import { VehicleListComponent } from './pages/ressources/vehicle-list/vehicle-list.component';
import { MenuService } from './shared/services/menu.service';
import { SinisterListComponent } from './pages/reservations/sinister-list/sinister-list.component';
import { StationListComponent } from './pages/ressources/station-list/station-list.component';
import { VehicleInformationsComponent } from './pages/ressources/vehicle-informations/vehicle-informations.component';
import { StationInformationsComponent } from './pages/ressources/station-informations/station-informations.component';
import { SocietyInformationsComponent } from './pages/users/society-informations/society-informations.component';
import { UserInformationsComponent } from './pages/users/user-informations/user-informations.component';
import { ReservationInformationsComponent } from './pages/reservations/reservation-informations/reservation-informations.component';
import { VehicleTabComponent } from './components/tabs/vehicle-tab/vehicle-tab.component';
import { ReservationTabComponent } from './components/tabs/reservation-tab/reservation-tab.component';
import { StationTabComponent } from './components/tabs/station-tab/station-tab.component';
import { SocietyTabComponent } from './components/tabs/society-tab/society-tab.component';
import { UserTabComponent } from './components/tabs/user-tab/user-tab.component';
import { HumanDateFormatDirective } from './shared/directives/human-date-format.directive';
import { PlanningComponent } from './components/planning/planning.component';
import { ReservationPlannerComponent } from './components/reservation-planner/reservation-planner.component';
import { SocietyPricesComponent } from './pages/users/society-prices/society-prices.component';
import { ReservationInvoicesComponent } from './pages/reservations/reservation-invoices/reservation-invoices.component';
import { ManagerStateOfCarInformationsComponent } from './components/modals/manager-state-of-car-informations/manager-state-of-car-informations.component';
import { ChangeReservationAmountsComponent } from './components/modals/change-reservation-amounts/change-reservation-amounts.component';
import { FindUserComponent } from './components/modals/find-user/find-user.component';
import { AddStationComponent } from './components/modals/add-station/add-station.component';
import { AddSocietyComponent } from './components/modals/add-society/add-society.component';
import { AddManagerStateOfCarComponent } from './components/modals/add-manager-state-of-car/add-manager-state-of-car.component';
import { AlertService } from './shared/services/alert.service';
import { MapService } from './shared/services/map.service';
import { PdfService } from './shared/services/pdf.service';
import { PhotoService } from './shared/services/photo.service';
import { ReservationsService } from './shared/services/reservations.service';
import { ClotureService } from './shared/services/cloture.service';
import { MticketService } from './shared/services/mticket.service';
import { SocietiesService } from './shared/services/societies.service';
import { StateOfCarService } from './shared/services/state-of-car.service';
import { StationsService } from './shared/services/stations.service';
import { TitleService } from './shared/services/title.service';
import { UsersService } from './shared/services/users.service';
import { VehiclesService } from './shared/services/vehicles.service';
import { AddVehicleComponent } from './components/modals/add-vehicle/add-vehicle.component';
import { InformationReservation } from './components/modals/information-reservation/information-reservation.component';
import { AddUserComponent } from './components/modals/add-user/add-user.component';
import { AddReservationComponent } from './components/modals/add-reservation/add-reservation.component';
import { DashboardMapComponent } from './components/dashboard-map/dashboard-map.component';
import { MapComponent } from './components/map/map.component';
import { MultiSearchComponent } from './components/multi-search/multi-search.component';
import { ChangeReservationPeriodComponent } from './components/modals/change-reservation-period/change-reservation-period.component';
import { ChangeReservationPeriodComponentMticket } from './components/modals/change-reservation-period-mticket/change-reservation-period-mticket.component';
import { DatepickerComponent } from './components/datepicker/datepicker.component';
import { SentryErrorHandler } from './shared/interfaces/sentry-error-handler';
import { DashboardTabComponent } from './components/tabs/dashboard-tab/dashboard-tab.component';
import { PositionStationComponent } from './components/modals/position-station/position-station.component';
import { ClientSupportComponent } from './components/client-support/client-support.component';
import { HoursDirective } from './shared/directives/hours.directive';
import { ChangeReservationDetailsComponent } from './components/modals/change-reservation-details/change-reservation-details.component';
import { RateManagementComponent } from './components/rate-management/rate-management.component';
import { RateManagementComponentVehicle } from './components/rate-management-vehicle/rate-management-vehicle.component';
import { StateOfCarInformationsComponent } from './components/modals/state-of-car-informations/state-of-car-informations.component';
import { PositionVehicleComponent } from './components/modals/position-vehicle/position-vehicle.component';
import { EditUserDocumentsComponent } from './components/modals/edit-user-documents/edit-user-documents.component';
import { VehicleLogsComponent } from './pages/ressources/vehicle-logs/vehicle-logs.component';
import { ChoiceValidationComponent } from './components/modals/choice-validation/choice-validation.component';
import { FindVehicleComponent } from './components/modals/find-vehicle/find-vehicle.component';
import { StatesOfCarManagementComponent } from './components/modals/states-of-car-management/states-of-car-management.component';
import { CompanyInformationsComponent } from './pages/companies/company-informations/company-informations.component';
import { RegisterComponent } from './pages/register/register.component';

@NgModule({
  declarations: [
    AppComponent,
    DashboardComponent,
    LoginComponent,
    RecoveryPasswordComponent,
    MenuComponent,
    SidemenuComponent,
    SubmenuComponent,
    SocietyListComponent,
    ReservationListComponent,
    CarSharingComponent,
    VirementsListComponent,
    GainComponent,
    ControlComponent,
    MyReservationComponent,
    UserListComponent,
    VehicleListComponent,
    SinisterListComponent,
    StationListComponent,
    VehicleInformationsComponent,
    StationInformationsComponent,
    SocietyInformationsComponent,
    UserInformationsComponent,
    ReservationInformationsComponent,
    VehicleTabComponent,
    ReservationTabComponent,
    StationTabComponent,
    SocietyTabComponent,
    UserTabComponent,
    HumanDateFormatDirective,
    StateOfCarInformationsComponent,
    PlanningComponent,
    ReservationPlannerComponent,
    SocietyPricesComponent,
    ReservationInvoicesComponent,
    ManagerStateOfCarInformationsComponent,
    ChangeReservationAmountsComponent,
    FindUserComponent,
    AddStationComponent,
    AddSocietyComponent,
    AddManagerStateOfCarComponent,
    AddVehicleComponent,
    InformationReservation,
    AddUserComponent,
    AddReservationComponent,
    DashboardMapComponent,
    MapComponent,
    MultiSearchComponent,
    ChangeReservationPeriodComponent,
    ChangeReservationPeriodComponentMticket,
    DatepickerComponent,
    DashboardTabComponent,
    PositionStationComponent,
    ClientSupportComponent,
    HoursDirective,
    ChangeReservationDetailsComponent,
    RateManagementComponent,
    RateManagementComponentVehicle,
    PositionVehicleComponent,
    EditUserDocumentsComponent,
    VehicleLogsComponent,
    ChoiceValidationComponent,
    FindVehicleComponent,
    StatesOfCarManagementComponent,
    CompanyInformationsComponent,
    RegisterComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CommonModule,
    AppRoutingModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    FormsModule,
    ReactiveFormsModule
  ],
  providers: [
    RestApiService,
    SessionService,
    MenuService,
    AlertService,
    MapService,
    PdfService,
    PhotoService,
    ReservationsService,
    ClotureService,
    MticketService,
    SocietiesService,
    StateOfCarService,
    StationsService,
    TitleService,
    UsersService,
    VehiclesService,
    { provide: ErrorHandler, useClass: SentryErrorHandler },
    { provide: LocationStrategy, useClass: HashLocationStrategy }
  ],
  bootstrap: [
    AppComponent
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]
})
export class AppModule { }

// required for AOT compilation
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}